import React, { useState } from 'react';
import RangeForm from '../../components/forms/RangeForm';
import { useRangeApi } from '../../hooks/useRangeApi';
import { useNavigate } from 'react-router-dom';
import { RangeDTO } from '../../services/apiClient';
import Button from '../../components/common/Button';

const PublicRangeCreate: React.FC = () => {
  const { create, isLoading } = useRangeApi();
  const navigate = useNavigate();
  const backgroundImage = '/images/NS_Pattern%201_Navy_2025.webp';
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const handleSubmit = async (data: RangeDTO) => {
    try {
      await create(data);
      setSubmissionSuccess(true);
    } catch (error) {
      console.error('Error creating Range:', error);
    }
  };

  const handleCancel = () => {
    navigate('/');
  };

  if (submissionSuccess) {
    return (
      <div className="relative min-h-screen flex items-center justify-center px-4 py-8 sm:py-12">
        <div
          className="absolute inset-0 w-full min-h-full bg-cover bg-center transition-opacity duration-500 -z-10"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg text-center z-10">
          <img
            src="/images/logo-linnear-navy.png"
            alt="Natshoot Logo"
            className="mx-auto mb-6 w-56"
          />
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Thank You!
          </h2>
          <p className="text-gray-600 mb-6">
            Your range application has been submitted successfully. We will review it and get back to you soon.
          </p>
          <Button
            onClick={() => navigate('/')}
            variant="primary"
          >
            Return to Home
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 py-8 sm:py-12">
      <div
        className="absolute inset-0 w-full min-h-full bg-cover bg-center transition-opacity duration-500 -z-10"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-5xl z-10">
        <img
          src="/images/logo-linnear-navy.png"
          alt="Natshoot Logo"
          className="mx-auto mb-6 w-56"
        />
        
        <h1 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Register Your Range
        </h1>
        
        <RangeForm
          initialValues={{} as RangeDTO}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isPublicView={true}
        />
      </div>
    </div>
  );
};

export default PublicRangeCreate;
